<script context="module">
	import { z } from "zod";
	export const name = "Rând (feed)";
	export const CustomFields = z.object({
		show_kicker: z.boolean().optional(),
		show_date: z.boolean().optional(),
		compact: z.boolean().optional(),
	});
</script>

<script>
	import Kicker from "./Kicker.svelte";
	import Stamp from "./Stamp.svelte";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	id || type || indexInContainer;

	$: content = data && data.content;
	$: cf = (data && data.custom_fields) || {};
	$: showKicker = cf.show_kicker !== false;
	$: showDate = cf.show_date !== false;
	$: compact = cf.compact === true;
</script>

{#if content}
	<article class="af-row af-item af-item--row" class:af-row--compact={compact} class:af-row--no-kicker={!showKicker}>
		{#if showKicker}
			<div class="af-row__kicker"><Kicker {content} /></div>
		{/if}
		<h3 class="af-row__title"><a href={content.url}>{content.title}</a></h3>
		{#if showDate}
			<div class="af-row__stamp"><Stamp {content} pattern="D MMMM YYYY, HH:mm" /></div>
		{/if}
	</article>
{/if}

<style lang="scss">
	/* flat feed line: hairlines only, no card, no radius */
	.af-row {
		display: grid;
		grid-template-columns: minmax(0, 1fr) auto;
		column-gap: var(--af-space-4);
		row-gap: var(--af-space-1);
		align-items: baseline;
		padding-block: var(--af-space-4);
		border-bottom: 1px solid var(--af-hairline);
		border-radius: var(--af-radius-none);

		&:last-child {
			border-bottom: 0;
		}
	}

	.af-row__kicker {
		grid-column: 1 / -1;
		min-width: 0;
		overflow-wrap: anywhere;

		:global(.af-kicker) {
			font-size: 0.6875rem;
			letter-spacing: 0.04em;
			line-height: 1.2;
		}
	}

	.af-row__title {
		min-width: 0;
		font: 600 1.25rem / 1.25 var(--af-font-serif);
		color: var(--af-ink);

		a {
			transition: color 0.15s var(--af-ease-out);

			&:hover {
				color: var(--af-brand);
			}
		}
	}

	.af-row--compact .af-row__title {
		font-size: var(--af-text-body-sm);
		line-height: 1.35;

		a {
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}
	}

	.af-row--compact {
		padding-block: var(--af-space-3);
	}

	.af-row__stamp {
		white-space: nowrap;
	}

	@media (min-width: 768px) {
		.af-row {
			grid-template-columns: 108px minmax(0, 1fr) auto;
		}

		.af-row__kicker {
			grid-column: auto;
		}

		.af-row--no-kicker {
			grid-template-columns: minmax(0, 1fr) auto;
		}
	}
</style>
